import { Currency } from '@/core/currency/interfaces';

const UZS: Currency = {
    name: 'Uzbekistani Som',
    demonym: 'Uzbekistani',
    majorSingle: 'Som',
    majorPlural: 'Som',
    codeNumeric: '860',
    symbol: 'сум',
    symbolNative: 'сум',
    minorSingle: 'Tiyin',
    minorPlural: 'Tiyin',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'UZS',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default UZS;
